import script from "./account.vue?vue&type=script&setup=true&lang=ts"
export * from "./account.vue?vue&type=script&setup=true&lang=ts"

import "./account.vue?vue&type=style&index=0&id=0f258d0d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f258d0d"]])

export default __exports__